(function() {

    angular
        .module("app")
        .controller("MessageCreateGraphicController", MessageCreateGraphicController)

    MessageCreateGraphicController.$inject = [
        "$rootScope",
        "$scope",
        "$timeout",
        "$uibModal",
        "$uibModalInstance",
        "userMessagingService",
        "messagesService",
        "messageBoardsService",
        "messageBoard"
    ]

    function MessageCreateGraphicController(
        $rootScope,
        $scope,
        $timeout,
        $uibModal,
        $uibModalInstance,
        userMessagingService,
        messagesService,
        messageBoardsService,
        messageBoard
    ){

        $rootScope.graphicMessageBoardID = messageBoard.id

        $scope.loadingModal = true
        $scope.loadedModal  = { visibility: "hidden" }
        $scope.loadedCanvas = { opacity: 0 }

        $scope.messageBoard = messageBoard

        $scope.messageNumber  = 1
        $scope.messageName    = "C001"
        $scope.messageNumbers = []
        $scope.isOverwrite    = false

        $scope.showConfirmOverwrite = false
        $scope.showConfirmCancel    = false

        const canvasReady = () => {

            document.removeEventListener("canvasReady", canvasReady)

            $timeout(() => {
                $scope.loadedCanvas = { opacity: 1 }
            }, 10)
        }

        document.addEventListener("canvasReady", canvasReady)

        const isReady = []

        const onReady = () => {
            if (isReady.indexOf(false) >= 0) {
                isReady[isReady.indexOf(false)] = true
            }

            if (isReady.indexOf(false) < 0) {
                gtag("event", "create_message", { action: "begin", device_id: $scope.messageBoard.device.id, type: "GRAPHIC" })

                $scope.loadingModal = false
                $scope.loadedModal  = { visibility: "visible" }
            }
        }

        isReady.push(false)
        messageBoardsService.getMessageNumbers($scope.messageBoard.id, (data) => {

            $scope.messageNumbers = []

            for (const n of data.existing) {
                $scope.messageNumbers.push({
                    number: n,
                    name:   $rootScope.generateMessageID("C", n),
                    exists: true
                })
            }

            for (const n of data.available) {
                $scope.messageNumbers.push({
                    number: n,
                    name:   $rootScope.generateMessageID("C", n),
                    exists: false
                })
            }

            if(data.available.length > 0) {
                $scope.messageNumber = data.available[0]
                $scope.isOverwrite = false
            } else {
                $scope.messageNumber = data.existing[0]
                $scope.isOverwrite = true
            }

            $scope.messageName = $rootScope.generateMessageID("C", $scope.messageNumber)

            onReady()

        })

        $scope.setMessageNumber = (messageSlot) => {

            if (messageSlot.exists) {
                $scope.isOverwrite = true
            } else {
                $scope.isOverwrite = false
            }

            $scope.messageNumber = messageSlot.number
            $scope.messageName   = $rootScope.generateMessageID("C", $scope.messageNumber)

        }

        $scope.cancel = (force) => {

            if (!force) {

                if ($scope.showConfirmCancel) {
                    return
                }

                messagesService.createGraphicMessageData($scope.messageNumber)
                $scope.messageData = messagesService.getGraphicMessageData()

                for (const pageID of Object.keys($scope.messageData.message.pixels)) {
                    const page = $scope.messageData.message.pixels[pageID]
                    for (const rowID of Object.keys(page)) {
                        const row = page[rowID]
                        for (const pixel of row) {
                            if (pixel > 0) {
                                $scope.showConfirmCancel = true
                                return
                            }
                        }
                    }
                }
            }

            gtag("event", "create_message", { action: "cancel", device_id: $scope.messageBoard.device.id, type: "GRAPHIC" })

            // changed this so the .then() never fires on message-board.controller for in_process
            $uibModalInstance.dismiss("cancel")

        }

        $scope.resume = () => {
            $scope.showConfirmCancel = false
        }

        $scope.cancelOverwrite = () => {
            $scope.activate = false
            $scope.showConfirmOverwrite = false
        }

        $scope.createNewMessage = (activate, force) => {

            messagesService.createGraphicMessageData($scope.messageNumber)
            $scope.messageData = messagesService.getGraphicMessageData()

            if (!force && $scope.isOverwrite) {

                $scope.showConfirmOverwrite = true
                $scope.activate = activate

            } else {

                $scope.working = true
                $scope.showConfirmOverwrite = false

                if (force) {
                    $scope.messageData.message.activate = $scope.activate
                } else {
                    $scope.messageData.message.activate = activate
                }

                messagesService.createMessage(
                    $scope.messageBoard.id,
                    $scope.messageData,

                    () => {
                        //Success
                        gtag("event", "create_message", { action: "complete", device_id: $scope.messageBoard.device.id, slot: $scope.messageNumber, type: "GRAPHIC" })
                        if (scope.messageData.message.activate) gtag("event", "display_change", { action: "complete", device_id: $scope.messageBoard.device.id, slot_name: $scope.messageName })

                        $scope.working = false
                        $uibModalInstance.close()
                        userMessagingService.success("Message Creation Request Sent")
                    },

                    (error) => {
                        //Failure
                        $scope.working = false
                        $uibModalInstance.dismiss("cancel")
                        userMessagingService.error("Message Creation Failed: " + error)
                    }
                )
            }
        }

        $scope.exportMessage = () => {

            messagesService.createGraphicMessageData($scope.messageNumber)
            $scope.messageData = messagesService.getGraphicMessageData()

            $scope.working = true
            $scope.showConfirmOverwrite = false

            messagesService.exportMessage(
                $scope.messageBoard.id,
                $scope.messageData,

                (filename) => {
                    //Success
                    $scope.working = false
                    $uibModalInstance.close()
                    userMessagingService.success("Message Exported to File: " + filename)
                },

                (error) => {
                    //Failure
                    $scope.working = false
                    $uibModalInstance.dismiss("cancel")
                    userMessagingService.error("Message Export Failed: " + error)
                }
            )
        }

        $scope.preview = () => {

            $scope.working = true

            $timeout(() => {

                messagesService.createGraphicMessageData($scope.messageNumber)
                $scope.messageData = messagesService.getGraphicMessageData()

                messagesService.previewMessage(
                    $scope.messageBoard.id,
                    $scope.messageData,

                    (data) => {
                        //Success
                        $scope.working = false
                        $scope.preview_image = data

                        $uibModal.open({
                            templateUrl: "app/modals/preview-message.view.html",
                            controller: "PreviewMessageModalController",
                            windowClass: "previewMessageModal",
                            size: "lg",
                            resolve: {
                                previewImage: () => {
                                    return $scope.preview_image
                                }
                            }
                        }).result.catch((res) => {
                            if (!(res === "cancel" || res === "escape key press")) {
                                throw res
                            }
                        })
                    },

                    () => {
                        //Failure
                        $scope.working = false
                    }
                )
            }, 100)
        }

        $scope.$on('$destroy', () => {
            $rootScope.graphicMessageBoardID = undefined
            if (graphicMessage !== undefined && (typeof graphicMessage.destroy === "function")) {
                graphicMessage.destroy()
            }
        })
    }
})()
